window.ApuListHelper = {
	rowsReplacer: function (key, value) {
		if (this[key] && !isNaN(this[key]) && this[key] instanceof Date) {
			const d = this[key];
			return d.getFullYear() + '-' + (d.getMonth() + 1).toString().padStart(2, '0') + '-' + d.getDate().toString().padStart(2, '0') +
				'T' + d.getHours().toString().padStart(2, '0') + ':' + d.getMinutes().toString().padStart(2, '0') + ':' +
				d.getSeconds().toString().padStart(2, '0');
		}
		return value;
	}
};

class ApuList extends Tango.Component {
	widgetDidMount() {
		const rows = this.state.rows;
		const _this = this;
		var app = new Vue({
			el: '#' + this.root,
			data: this.state,
			mounted() {
				this.updateAllContent();
			},
			methods: {
				updateAllContent() {
					var t = this;
					this.rows.forEach(function (row) {
						row.periods.forEach(function (period) {
							var id = 'comments_' + t.rowid(row, period);
							document.getElementById(id).innerText = period.comments;
						});
					});
				},
				rowid(row, period) {
					return row.docSubType_ID + '_' + row.tI_ID + '_' + row.channelType + '_' + row.isKA + '_' + moment(period.finishDate).format('YYYYMMDDHHmm');
				},
				openEventDialog: (e, row, period) => this.openEventDialog(e, row, period, {
					onSubmit: (rowel, row, period) => this.submitEventDialog(rowel, row, period)
				}),
				deleteEvent: (e, row, period) => this.deleteEvent(e, row, period),
				addZeroCrossingEvent: (e, row, period) => this.addZeroCrossingEvent(e, row, period),
				deleteZeroCrossingEvent: (e, row, period) => this.deleteZeroCrossingEvent(e, row, period),

				disableEditStartValue(row, periodidx) {
					return periodidx > 0 && ((row.periods[periodidx - 1].event && row.periods[periodidx - 1].event.eventType != '4') ||
						(row.periods[periodidx].event && (!row.periods[periodidx - 1].event || row.periods[periodidx - 1].event.eventType != '4')));
				},
				getNsiEventIcons(row) {
					const icons = [];
					row.periods.forEach(function (p) {
						if (p.event && p.event.startDate == p.event.finishDate && !p.visible) {
							const icon = {
								title: 'Событие ' +
									(p.event.eventType == 4 ? 'Замена счетчика' : 
									p.event.eventType == 5 ? 'Замена ТТ / ТН' :
									p.event.eventType == 6 ? 'Переворот' : '')
							};
							icons.push(icon);
						}
					});
					return icons;
				},
				disableEditFinishValue(row, periodidx) {
					return false;
					/*!row.periods[periodidx].event && periodidx + 1 < row.periods.length
						&& row.periods[periodidx + 1].event
						&& row.periods[periodidx + 1].event.eventType != '4'
						&& row.periods[periodidx + 1].event.eventType != '5'
						&& row.periods[periodidx + 1].event.eventType != '6'*/
				},
				getRowStartValue: (row, periodidx) => this.getRowStartValue(row, periodidx),
				getRowFinishValue: (row, periodidx) => this.getRowFinishValue(row, periodidx),
				inputStartValue(event, row, periodidx) {
					const period = row.periods[periodidx];
					this.isNumber(event, period, function (val, upd) {
						if (period.event)
							period.event.startValue = val;
						else if (periodidx > 0 && row.periods[periodidx - 1].event && row.periods[periodidx - 1].event.eventType == '4') {
							row.periods[periodidx - 1].event.finishValue = val;
							if (upd) app.$forceUpdate();
						}
						else
							row.startValue = val;
					});
				},
				inputFinishValue(event, row, periodidx) {
					const period = row.periods[periodidx];
					this.isNumber(event, period, function (val, upd) {
						if (period.event)
							period.event.finishValue = val;
						else if (periodidx + 1 < row.periods.length && row.periods[periodidx + 1].event) {
							row.periods[periodidx + 1].event.startValue = val;
							if (upd) app.$forceUpdate();
						}
						else
							row.finishValue = val;
					});
				},
				inputComments(event, row, periodidx) {
					const period = row.periods[periodidx];
					//var sel = window.getSelection();
					//var range = document.createRange();
					//var offset = sel.getRangeAt(0).startOffset;
					period.comments = event.target.innerText;
					//if (event.target.firstChild) {
					//	window.setTimeout(function () {
					//		sel.removeAllRanges();
					//		range.setStart(event.target.firstChild, offset);
					//		sel.addRange(range);
					//	}, 0);
					//}
				},
				copyStart2Finish(row, periodidx) {
					const startValue = this.getRowStartValue(row, periodidx);

					const thisEvent = row.periods[periodidx].event;
					const nextPeriod = periodidx + 1 < row.periods.length ? row.periods[periodidx + 1] : null;
					const nextEvent = nextPeriod?.event;

					if (thisEvent)
						thisEvent.finishValue = startValue;
					else if (nextEvent && ['4', '5', '6'].indexOf(nextEvent.eventType.toString()) >= 0) {
						nextEvent.startValue = startValue;
						app.$forceUpdate();
					}
					else
						row.finishValue = startValue;
				},
				getRowDiffValue(row, periodidx) {
					const fv = this.getRowFinishValue(row, periodidx);
					const sv = this.getRowStartValue(row, periodidx);

					if (fv == null || sv == null || isNaN(fv) || isNaN(sv) || fv < 0 || sv < 0)
						return null;

					if (row.periods[periodidx].zeroCrossingEvent)
						return Math.round(row.periods[periodidx].digitСapacity / 10, 0) * 10 / 1000 - sv + fv;
					else
						return fv - sv;			
				},
				getRowResultValue(row, periodidx) {
					const diff = this.getRowDiffValue(row, periodidx);
					const coef = row.periods[periodidx].coef;
					var v = diff != null && diff >= 0 && coef > 0 ? coef * diff : null;
					const ev = row.periods[periodidx].event;
					if (ev && !ev.showInNewRow) {
						if (ev.eventType == '2') {
							v = (v ?? 0) + ev.eventValue;
						}
						else if (ev.eventType == '3' && (new Date(row.startDate).getTime() != new Date(ev.startDate).getTime() ||
							new Date(row.finishDate).getTime() != new Date(ev.finishDate).getTime())) {
							v = v ? v - ev.eventValue : null;
						}
					}
					return v;
				},
				getRowDivergenceValue(row) {
					var v = 0;
					for (let i = 0; i < row.periods.length; i++) {
						var vd = (row.periods[i].coef || 0) * (this.getRowFinishValue(row, i) - this.getRowStartValue(row, i));
						const ev = row.periods[i].event;
						if (!ev || ev.eventType < 4) {
							v += vd;
						}
					}
					return v - row.energyValue;
				},
				getRowDivergenceColor(row, periodidx) {
					if (periodidx > 0) return '';
					var v = this.getRowDivergenceValue(row);
					var c = ''
					if (row.energyValue == 0)
						c = 'background-color:#eaeaea';
					else if (Math.abs(v) > 10)
						c = 'background-color:#f08080';
					else if (Math.abs(v) > 1)
						c = 'background-color:#ffcc99';

					return c;
				},
				showNewRow: (row, period) => this.#showNewRow(row, period),
				toLocaleStrEn: (val, period) => val != null && !isNaN(val) ? val.toLocaleString('en', { minimumFractionDigits: 0, maximumFractionDigits: period ? period.digits : 3, useGrouping: false }) : '',
				toLocaleStr: (val, period) => val != null && !isNaN(val) ? val.toLocaleString('ru-RU', { minimumFractionDigits: period ? period.digits : 0, maximumFractionDigits: period ? period.digits : 3 }) : '',
				isNumber: function (evt, period, setProp) {
					var userVal = evt.target.value;
					evt = (evt) ? evt : window.event;
					var regex = new RegExp('^\\d+\\.?(\\d?){' + period.digits.toString() + '}$');
					if (!regex.test(userVal)) {
						regex = new RegExp('^\\d+\\.?(\\d?){' + period.digits.toString() + '}');
						var val = userVal.replace(',', '.').replaceAll(/[^0-9.]/g, '');
						var m = val.match(regex);
						if (m) {
							userVal = m[0];
							setProp(parseFloat(userVal), true);
						}
						else {
							userVal = '';
							setProp(null, true);
						}
					}
					else
						setProp(parseFloat(userVal), !(userVal.endsWith('.') || userVal.endsWith(',')));
				},
				documentMenuInit: () => this.documentMenuInit('document-menu'),
				getFirstVisibleIndex: function (row) {
					for (let i = 0; i < row.periods.length; i++) {
						if (row.periods[i].visible)
							return i;
					}
				}
			}
		});

		this.documentMenuInit('document-menu');
		this.documentMenuInit('document-nsimenu')

		const evntList = this.props.au.state.ctrl[this.props.evntListID];
		if (evntList) {
			evntList.onRowChecking = new Tango.Event(ctx => this.#addNSIEventVal(ctx));
			evntList.onRowChecked = new Tango.Event(ctx => this.#addNSIEvent(ctx));
			evntList.onRowUnchecked = new Tango.Event(ctx => this.#deleteNSIEvent(ctx));

			const btns = document.querySelectorAll('#' + this.props.evntListID + ' .addfilebtn');
			for (let i = 0; i < btns.length; i++) {
				const btn = btns[i];
				btn.onclick = e => this.#openNSIEventDialog(e);
				if (btn.parentNode.parentNode.classList.contains('checked'))
					btn.classList.remove('hide');
			}
			const nsidocs = document.querySelectorAll('#' + this.props.evntListID + ' .nsidocument');
			for (let i = 0; i < nsidocs.length; i++) {
				const nsidoc = nsidocs[i];
				if (nsidoc.parentNode.parentNode.classList.contains('checked'))
					this.#readNSIEventMenu(nsidoc);
			}
		}
	}

	getRowStartValue(row, periodidx) {
		const thisEvent = row.periods[periodidx].event;
		const prevEvent = periodidx > 0 ? row.periods[periodidx - 1].event : null;

		if (thisEvent && !prevEvent)
			return row.periods[periodidx].event.startValue;

		if (prevEvent)
			if (prevEvent.eventType == '5')
				return prevEvent.startValue;
			else if (prevEvent.eventType == '6') {
				const reverseRow = rows.find(x => x.tI_ID == row.tI_ID && x.isKA == row.isKA &&
					((x.channelType == 1 && row.channelType == 2) || (x.channelType == 2 && row.channelType == 1)));
				if (reverseRow) {
					const reversePrevEvent = periodidx > 0 ? reverseRow.periods[periodidx - 1].event : null;
					return reversePrevEvent.startValue;
				}
				else
					return null;
			}
			else
				return prevEvent.finishValue;

		return row.startValue;
	}

	getRowFinishValue(row, periodidx) {
		const thisEvent = row.periods[periodidx].event;
		const nextEvent = periodidx + 1 < row.periods.length ? row.periods[periodidx + 1].event : null;

		if (thisEvent)
			return thisEvent.finishValue;

		if (nextEvent)
			return nextEvent.startValue;

		return row.finishValue;
	}

	#openNSIEventDialog(event) {
		const rowel = event.currentTarget.parentNode.parentNode;
		const parms = this.#getNSIRowParms(rowel);
		const row = this.state.rows.find(x => x.tI_ID == parms.tI_ID && x.isKA == parms.isKA);
		const period = row.periods.find(x => x.event && x.event.eventType == parms.eventType && new Date(x.startDate).getTime() == parms.eventDate.getTime() && new Date(x.finishDate).getTime() == parms.eventDate.getTime());

		this.openEventDialog(event, row, period, {
			onSubmit: (rowel, row, period) => {
				this.submitEventDialog(rowel, row, period);
				const el = rowel.querySelector('.nsidocument');
				this.#readNSIEventMenu(el);
			}
		});
	}

	#getNSIRowParms(row) {
		const rowidattr = row.getAttribute('data-rowid');
		const otherattr = row.getAttribute('data-otherparms');
		const rowid = rowidattr.split('_');
		const other = otherattr.split('_');
		return {
			rowid: rowidattr,
			tI_ID: parseInt(rowid[0]),
			isKA: rowid[1] == 'True',
			eventType: parseInt(rowid[2]),
			eventDate: this.props.moment(rowid[3], 'DDMMYYYYHHmm').toDate(),
			prevValue: other[0],
			digits: other[1],
			digitСapacity: other[2] != '' ? parseFloat(other[2]) : 0
		};
	}

	#addNSIEventVal(ctx) {
		ctx.parms = this.#getNSIRowParms(ctx.tr);
		ctx.rows = this.state.rows.filter(x => x.tI_ID == ctx.parms.tI_ID && x.isKA == ctx.parms.isKA);

		const check = ctx.rows.find(x => x.periods.find(x2 => x2.event &&
			![4, 5, 6].includes(x2.event.eventType) &&
			new Date(x2.startDate).getTime() <= new Date(ctx.parms.eventDate).getTime() &&
			new Date(x2.finishDate).getTime() >= new Date(ctx.parms.eventDate).getTime()));
		if (check) {
			alert('В акте первичного учета создано событие по учету электроэнергии, которое пересекается с редактируемым событием по прибору учета. Для выполнения операции необходимо удалить данное событие по учету электроэнергии.');
			return false;
		}
	}

	#addNSIEvent(ctx) {
		const parms = ctx.parms;

		for (let i = 0; i < ctx.rows.length; i++) {
			const row = ctx.rows[i];
			var j = row.periods.findIndex(x => new Date(x.startDate).getTime() <= parms.eventDate.getTime() && new Date(x.finishDate).getTime() >= parms.eventDate.getTime());
			const period = row.periods[j];

			const event = {
				apU_ItemEvent_ID: 0,
				apU_Item_ID: 0,
				startDate: parms.eventDate,
				finishDate: parms.eventDate,
				eventType: parms.eventType,
				showInNewRow: true,
				notes: null,
				files: []
			};

			const firstRow = this.state.rows.find(x => x.tI_ID == row.tI_ID && x.isKA == row.isKA && x.rowSeqNo == 1);

			if (!period.event) {
				if (parms.eventDate.getTime() > new Date(period.startDate).getTime()) {
					const periodBefore = Object.assign({}, period);
					periodBefore.event = null;
					periodBefore.zeroCrossingEvent = null;
					periodBefore.finishDate = new Date(parms.eventDate.getTime() - 1 * 60000);
					if (parms.eventType == 4)
						periodBefore.meterSerialNumber = parms.prevValue;
					if (parms.eventType == 5)
						periodBefore.coef = parms.prevValue != '' ? parseInt(parms.prevValue) : null;
					if (parms.digits > 0) {
						periodBefore.digits = parms.digits;
						periodBefore.placeholder = '0.' + '00000000'.substring(0, period.digits);
						periodBefore.digitСapacity = parms.digitСapacity
					}
					row.periods.splice(j, 0, periodBefore);
					j++;
					firstRow.rowSpan++;
				}
				if (parms.eventDate.getTime() < new Date(period.finishDate).getTime()) {
					const periodAfter = Object.assign({}, period);
					periodAfter.event = null;
					periodAfter.zeroCrossingEvent = null;
					periodAfter.startDate = new Date(parms.eventDate.getTime());
					row.periods.splice(j + 1, 0, periodAfter);
					firstRow.rowSpan++;
				}
				if (event.eventType == 4 && j > 0) {
					row.periods[j - 1].meterSerialNumber = parms.prevValue;
					row.periods[j - 1].digits = parms.digits;
					row.periods[j - 1].digitСapacity = parms.digitСapacity;
					row.periods[j - 1].placeholder = '0.' + '00000000'.substring(0, row.periods[j - 1].digits);
				}

				period.event = event;
				period.startDate = parms.eventDate;
				period.finishDate = parms.eventDate;

				period.visible = false;
				firstRow.rowSpan--;
			}
			else if (period.event && [4, 5, 6].includes(period.event.eventType)) {
				const periodAfter = Object.assign({}, period);
				periodAfter.event = event;
				row.periods.splice(j + 1, 0, periodAfter);
				firstRow.rowSpan++;
			}
		}
		const btn = document.querySelector('[data-rowid="' + parms.rowid + '"] .addfilebtn');
		btn.classList.remove('hide');
		const img = document.querySelector('[data-rowid="' + parms.rowid + '"] .nsidocument');
		this.#readNSIEventMenu(img);
	}

	#deleteNSIEvent(ctx) {
		const parms = this.#getNSIRowParms(ctx.tr);
		const rows = this.state.rows.filter(x => x.tI_ID == parms.tI_ID && x.isKA == parms.isKA)
		for (let i = 0; i < rows.length; i++) {
			const row = rows[i];
			var j = row.periods.findIndex(x => x.event && new Date(x.event.startDate).getTime() == parms.eventDate.getTime() && new Date(x.event.finishDate).getTime() == parms.eventDate.getTime());


			if (j > 0) {
				const firstRow = this.state.rows.find(x => x.tI_ID == row.tI_ID && x.isKA == row.isKA && x.rowSeqNo == 1);
				if (row.periods[j].event.eventType == 4 && j < row.periods.length - 1 && row.periods[j + 1].meterSerialNumber) {
					row.periods[j - 1].meterSerialNumber = row.periods[j + 1].meterSerialNumber;
					row.periods[j - 1].digits = row.periods[j + 1].digits;
					row.periods[j - 1].placeholder = row.periods[j + 1].placeholder;
				}
				if (j < row.periods.length - 1 && !row.periods[j - 1].event && !row.periods[j + 1].event) {
					row.periods[j + 1].startDate = row.periods[j - 1].startDate;
					row.periods.splice(j - 1, 1);
					j--;
					firstRow.rowSpan--;
				}

				row.periods.splice(j, 1);
			}
		}
		const btn = document.querySelector('[data-rowid="' + parms.rowid + '"] .addfilebtn');
		btn.classList.add('hide');
		const imgdoc = document.querySelector('[data-rowid="' + parms.rowid + '"] .document-nsimenu-no');
		if (!imgdoc.classList.contains('hide')) imgdoc.classList.add('hide');
		const menudoc = document.querySelector('[data-rowid="' + parms.rowid + '"] .document-nsimenu-init');
		if (!menudoc.classList.contains('hide')) menudoc.classList.add('hide');
	}

	#showNewRow(row, period) {
		if (!period.event)
			return false;

		return (period.event.eventType == '2' || period.event.eventType == '3') && period.event.showInNewRow &&
			new Date(row.startDate).getTime() == new Date(period.event.startDate).getTime() &&
			new Date(row.finishDate).getTime() == new Date(period.event.finishDate).getTime();
	}

	#showParmsBlock(period) {
		return !(period.event && [4,5,6].includes(period.event.eventType));
	}

	openEventDialog(event, row, period, dialogOptions) {
		const d = document.getElementById(this.props.dialogID);
		const ctrl = document.getElementById(this.root);

		d.querySelector('.modal-title').textContent = 'Событие по ТИ ' + row.tiName;

		const container = this.props.cu.getThisOrParent(ctrl, function (n) { return n.hasAttribute && n.hasAttribute('data-c-prefix'); });
		const rowel = this.props.cu.getRow(event.currentTarget);
		const prefix = container.getAttribute('data-c-prefix');

		const form = d.querySelector('form');
		const parmsBlock = d.querySelector('.parmsblock');
		const validation = d.querySelector('.validation');
		//const ch1 = d.querySelector('input[name="channel_1"]');
		//const ch2 = d.querySelector('input[name="channel_2"]');
		const ch = d.querySelector('span[name="channel"]');
		const eventtype = d.querySelector('select[name="eventtype"]');
		const val = d.querySelector('input[name="val"]');
		const newRowField = d.querySelector('#' + prefix + '_newrow_field');
		const valField = d.querySelector('#' + prefix + '_val_field');
		const newRow = this.props.btnSwitchCtor(prefix + '_newrow');
		const addNote = this.props.btnSwitchCtor(prefix + '_addnote');
		const addNoteCb = d.querySelector('input[name="addnote"]');
		const note = d.querySelector('textarea[name="note"]');
		const docstitle = d.querySelector('.docstitle');
		const selectfile = d.querySelector('input[name="selectfile"]');
		const selectfile_text = document.getElementById(selectfile.id + '_selected');
		const row_selectfile_text = rowel.querySelector('.eventdata .existedDocs');

		validation.innerHTML = '';

		const initChannels = v => {
			//if (v != 1) { // пока не поддерживаем возможность создавать для двух каналов одновременно
			if (row.channelType == 1) {
				ch.innerText = "Прием";
				//ch1.onclick = () => { return false };
				//ch2.cheched = false;
				//ch2.disabled = true;
			} else {
				ch.innerText = "Отдача";
				//ch1.disabled = true;
				//ch1.cheched = false;
				//ch2.onclick = () => { return false };
			}
			//} else {
			//	ch1.onclick = null;
			//	ch2.onclick = null;
			//	ch1.disabled = false;
			//	ch2.disabled = false;
			//}

			//if (row.channelType == 1) {
			//	ch1.checked = true;
			//} else {
			//	ch2.checked = true;
			//}
		};

		form.reset();

		if (this.#showParmsBlock(period))
			parmsBlock.classList.remove('hide');
		else
			parmsBlock.classList.add('hide');

		newRow.setValue(false);
		addNote.setValue(false);
		note.disabled = true;

		eventtype.disabled = period.event && !period.event.toDelete;
		docstitle.style.display = 'none';

		if (period.event && (period.event.eventType == 2 || period.event.eventType == 3)) {
			newRowField.style.display = '';
		} else {
			if (!period.event) {
				newRowField.style.display = '';
				newRow.setValue(true);
			}
			else
				newRowField.style.display = 'none';
		}
		valField.style.display = newRowField.style.display;

		if (period.event) {
			const fd = new Date(period.event.finishDate);
			fd.setMinutes(fd.getMinutes() - 29);
			const sd = new Date(period.event.startDate);
			daterangepickerproxy.setValue(prefix + '_eventpp', sd, fd);

			eventtype.value = period.event.eventType;
			val.value = period.event.eventValue;

			newRow.setValue(period.event.showInNewRow);
			addNote.setValue(period.event.notes);

			note.value = period.event.notes;
			note.disabled = !period.event.notes;

			if (period.event.existedDocs) {
				const arr = period.event.existedDocs.split(',');
				const fieldState = this.props.au.state.ctrl[selectfile.id + '_str'].selectedvalues;
				const dialogState = this.props.au.state.ctrl[selectfile.id + '_str_list'].selectedvalues;
				for (var i = 0; i < arr.length; i++) {
					fieldState.push(arr[i]);
					dialogState.push(arr[i]);
				}

				selectfile_text.innerHTML = row_selectfile_text.innerHTML;
			}

			const existedFiles = [];

			var no = 1;
			for (let i = 0; i < period.event.files.length; i++) {
				const file = period.event.files[i];
				if (!file.document_ID) {
					const fileupl = d.querySelector('input[data-no="' + no + '"]');
					const subtypeid = d.querySelector('select[name="acttype_' + no + '"]');
					const docdate = d.querySelector('input[name="actdate_' + no + '"]');
					const docno = d.querySelector('input[name="actno_' + no + '"]');
					subtypeid.value = file.docSubType_ID;
					if (file.docDate && !isNaN(file.docDate))
						docdate.value = file.docDate.getDate() + '.' + (file.docDate.getMonth() + 1).toString().padStart(2, '0') + '.' + file.docDate.getFullYear();
					docno.value = file.docNo;

					const parent = fileupl.parentNode;
					parent.removeChild(fileupl);
					const rowfileupl = document.getElementById('actfile_' + file.file_ID);
					rowfileupl.setAttribute('data-no', no);
					parent.appendChild(rowfileupl);

					no++;
				}
				else {
					existedFiles.push(file);
				}
			}

			if (existedFiles.length > 0) {
				const tbl = document.createElement('table');
				tbl.classList.add('listviewtable');
				tbl.classList.add('existedfiles');
				tbl.style.margin = '8px 0';

				for (let i = 0; i < existedFiles.length; i++) {
					const file = existedFiles[i];
					const tr = document.createElement('tr');
					const td1 = document.createElement('td');
					const td2 = document.createElement('td');
					tr.appendChild(td1);
					tr.appendChild(td2);

					td1.innerText = file.docSubTypeTitle + (file.docNo ? ' №' + file.docNo : '') + (file.docDate ? ' от ' + (new Date(file.docDate)).toLocaleDateString("ru-RU") + ' ' : '');
					td1.style.width = '100%';
					const a = document.createElement('a');
					const setDelete = e => {
						file.toDelete = true;
						td1.style.textDecoration = 'line-through';
						a.innerText = 'отменить\xa0удаление';
						a.onclick = setUndelete;
					};
					const setUndelete = e => {
						file.toDelete = false;
						td1.style.textDecoration = '';
						a.innerText = 'удалить';
						a.onclick = setDelete;
					};
					if (file.toDelete) {
						a.innerText = 'отменить\xa0удаление';
						td1.style.textDecoration = 'line-through';
						a.onclick = setUndelete;
					} else {
						a.innerText = 'удалить';
						a.onclick = setDelete;
					}
					td2.appendChild(a);


					tbl.appendChild(tr);
				}
				
				docstitle.style.display = '';
				docstitle.insertAdjacentElement('afterend', tbl);
			}
		}
		else {
			const fd = new Date(period.finishDate);
			fd.setMinutes(fd.getMinutes() - 29);
			const sd = new Date(period.startDate);
			daterangepickerproxy.setValue(prefix + '_eventpp', sd, fd);
		}

		initChannels();

		eventtype.onchange = e => {
			const val = e.currentTarget.value;
			initChannels(parseInt(val));
			if (val == '2' || val == '3') {
				newRowField.style.display = '';
				newRow.setValue(true);
			} else {
				newRowField.style.display = 'none';
				newRow.setValue(false);
			}
			valField.style.display = newRowField.style.display;
		};

		addNoteCb.onchange = e => {
			note.disabled = !e.currentTarget.checked;
		}

		dialog.open(d);

		const btn = d.querySelector('.modal-footer button[type="submit"]');
		btn.onclick = e => {
			dialogOptions.onSubmit(rowel, row, period);
		};

		const closeBtn = d.querySelector('.modal-footer button[type="button"]');
		closeBtn.onclick = e => {
			this.closeEventDialog(e.currentTarget, rowel, row, period);
		};
		const closeBtn2 = d.querySelector('.modal-header button[type="button"]');
		closeBtn2.onclick = e => {
			this.closeEventDialog(e.currentTarget, rowel, row, period);
		};
	}

	#fillFootnotes(rows) {
		var footnote = '';
		rows.forEach(function (r) {
			r.footnotes = '';
			r.periods.forEach(function (p) {
				p.footnote = null;
				if (p.event && p.event.notes) {
					footnote += '*';
					p.footnote = footnote;
					r.footnotes += p.footnote + ' ';
				}
			});
		});
		for (var r1 = 0; r1 < rows.length; r1++)
			for (var r2 = r1 + 1; r2 < rows.length; r2++)
				if (rows[r2].tI_ID == rows[r1].tI_ID)
					rows[r2].periods.forEach(function (p) {
						if (p.footnote)
							rows[r1].footnotes += p.footnote + ' ';
					});
	}

	deleteEvent(event, row, period) {
		const d = document.getElementById(this.props.deleteDialogID);
		var _this = this;
		const rowel = _this.props.cu.getRow(event.currentTarget);
		const eventdata = rowel.querySelector('.eventdata');
		const rows = _this.state.rows;

		dialog.open(d, e => {
			var i = row.periods.findIndex(p => p.startDate == period.startDate && p.finishDate == period.finishDate);

			if (i > 0) {
				if (!row.periods[i - 1].event) {
					period.startDate = row.periods[i - 1].startDate;
					row.periods.splice(i - 1, 1);
					const firstRow = _this.state.rows.find(x => x.tI_ID == row.tI_ID && x.isKA == row.isKA && x.rowSeqNo == 1);
					firstRow.rowSpan--;
					i--;
				}
			}

			if (i + 1 < row.periods.length) {
				if (!row.periods[i + 1].event) {
					period.finishDate = row.periods[i + 1].finishDate;
					period.meterSerialNumber = row.periods[i + 1].meterSerialNumber;
					period.digits = row.periods[i + 1].digits;
					period.digitCapacity = row.periods[i + 1].digitCapacity;
					period.placeholder = row.periods[i + 1].placeholder;
					row.periods.splice(i + 1, 1);
					const firstRow = _this.state.rows.find(x => x.tI_ID == row.tI_ID && x.isKA == row.isKA && x.rowSeqNo == 1);
					firstRow.rowSpan--;
				}
			}

			if (this.#showNewRow(row, period)) {
				const firstRow = _this.state.rows.find(x => x.tI_ID == row.tI_ID && x.isKA == row.isKA && x.rowSeqNo == 1);
				firstRow.rowSpan--;
			}

			period.event = null;
			period.comments = null;
			this.#fillFootnotes(rows);
			eventdata.innerHTML = '';			
		});
	}

	addZeroCrossingEvent(event, row, period) {
		period.zeroCrossingEvent = {
			apU_ItemEvent_ID: 0,
			apU_Item_ID: 0,
			startDate: period.startDate,
			finishDate: period.finishDate,
			eventType: 7
		};
	}

	deleteZeroCrossingEvent(event, row, period) {
		const d = document.getElementById(this.props.deleteDialogID);
		dialog.open(d, e => {
			period.zeroCrossingEvent = null;
		});
	}

	serializeRows(rows) {
		document.getElementsByName('rows')[0].value = encodeURIComponent(JSON.stringify(rows, ApuListHelper.rowsReplacer));
	}

	submitEventDialog(rowel, row, period) {
		const rows = this.state.rows;
		const d = document.getElementById(this.props.dialogID);
		const form = d.querySelector('form');
		const validationBlock = d.querySelector('.validation');
		
		const valMsg = [];
		const data = {};
		var event = {};

		const selectfile = d.querySelector('input[name="selectfile"]');


		this.props.cu.processElementValue(form, (key, value) => {
			if (!key.startsWith('actfile'))
				data[key] = value;
		});

		if (this.#showParmsBlock(period)) {
			const pp = daterangepickerproxy.getValue('eventpp', data);
			pp.to.setMinutes(pp.to.getMinutes() + 29);

			const periodStartDate = new Date(period.startDate);
			const periodFinishDate = new Date(period.finishDate);
			const rowStartDate = new Date(row.startDate);
			const rowFinishDate = new Date(row.finishDate);

			const initialShowNewRow = this.#showNewRow(row, period);

			var periodIdx = row.periods.findIndex(p => p.startDate == period.startDate && p.finishDate == period.finishDate);

			event = {
				apU_ItemEvent_ID: period.event ? period.event.apU_ItemEvent_ID : 0,
				apU_Item_ID: period.event ? period.event.apU_Item_ID : 0,
				startDate: pp.from,
				finishDate: pp.to,
				eventType: period.event ? period.event.eventType : data.eventtype,
				showInNewRow: data.newrow,
				eventValue: parseFloat(data.val),
				notes: data.addnote ? data.note : null,
				startValue: period.event ? period.event.startValue : this.getRowStartValue(row, periodIdx),
				finishValue: period.event ? period.event.finishValue : this.getRowFinishValue(row, periodIdx),
				files: period.event ? period.event.files : null,
				existedDocs: selectfile.value,
				title: period.event ? period.event.title : ("Событие " + form.eventtype.options[form.eventtype.selectedIndex].text)
			};

			if (isNaN(event.startDate.getTime()) || isNaN(event.finishDate.getTime())) {
				valMsg.push('Необходимо задать период события');
			}
			if (event.startDate.getTime() > event.finishDate.getTime()) {
				valMsg.push('Дата начала периода должна быть меньше даты окончания');
			}
			if (event.startDate.getTime() < rowStartDate.getTime() || event.finishDate.getTime() > rowFinishDate.getTime()) {
				valMsg.push('Период события должен входить в период акта');
			}
			if (event.startDate.getTime() < periodStartDate.getTime() || event.finishDate.getTime() > periodFinishDate.getTime()) {
				valMsg.push('Период события должен входить в период строки акта');
			}
			if ((event.eventType == 2 || event.eventType == 3) && !event.eventValue) {
				valMsg.push('Необходимо ввести объем электроэнергии по событию');
			}
			if (event.eventValue && event.eventValue < 0) {
				valMsg.push('Объем электроэнергии по событию не может быть отрицательным');
			}


			validationBlock.innerHTML = '';
			if (valMsg.length > 0) {
				this.props.au.postEventFromElementWithApiResponse(validationBlock).then(function () {
					const validation = d.querySelector('.validation-body');
					for (let i = 0; i < valMsg.length; i++) {
						const m = document.createElement('p');
						m.innerText = valMsg[i];
						validation.appendChild(m);
					}
					validation.scrollIntoView();
				});
				return;
			}

			const sameRow = (event.eventType == '2' || event.eventType == '3') && !event.showInNewRow;

			// если тип "Недоучет", "Излишний учет электроэнергии" 
			// + выключено "Выводить объем недоучтенной / излишне учтенной э/э отдельной строкой"
			// то строки не разбиваем
			if (!sameRow) {

				if (pp.from.getTime() > periodStartDate.getTime() && (periodIdx == 0 || !period.event)) {
					const periodBefore = Object.assign({}, period);
					periodBefore.event = null;
					periodBefore.zeroCrossingEvent = null;
					periodBefore.finishDate = new Date(pp.from.getTime() - 1 * 60000);
					row.periods.splice(periodIdx, 0, periodBefore);
					periodIdx++;
					const firstRow = this.state.rows.find(x => x.tI_ID == row.tI_ID && x.isKA == row.isKA && x.rowSeqNo == 1);
					firstRow.rowSpan++;
				}

				if (pp.to.getTime() < periodFinishDate.getTime() && (periodIdx + 1 == row.periods.length || !period.event)) {
					const periodAfter = Object.assign({}, period);
					periodAfter.event = null;
					periodAfter.zeroCrossingEvent = null;
					periodAfter.startDate = new Date(pp.to.getTime() + 1 * 60000);
					row.periods.splice(periodIdx + 1, 0, periodAfter);
					const firstRow = this.state.rows.find(x => x.tI_ID == row.tI_ID && x.isKA == row.isKA && x.rowSeqNo == 1);
					firstRow.rowSpan++;
				}

				period.startDate = pp.from;
				period.finishDate = pp.to;
			}

			period.event = event;
			this.#fillFootnotes(rows);

			if (initialShowNewRow != this.#showNewRow(row, period)) {
				const firstRow = this.state.rows.find(x => x.tI_ID == row.tI_ID && x.isKA == row.isKA && x.rowSeqNo == 1);
				if (!initialShowNewRow)
					firstRow.rowSpan++;
				else
					firstRow.rowSpan--;
			}
		}
		else {
			event = period.event;
			event.existedDocs = selectfile.value;
			this.serializeRows(rows);
		}

		dialog.close(d);

		const submitFile = file => {
			const no = file.getAttribute('data-no');
			var fileguid = '';
			if (file.hasAttribute('data-id')) {
				fileguid = file.getAttribute('data-id');
				const filedata = event.files.find(f => f.file_ID == fileguid);
				filedata.docSubType_ID = data['acttype_' + no];
				filedata.docNo = data['actno_' + no];
				filedata.docDate = this.props.moment(data['actdate_' + no], 'DD.MM.YYYY').toDate();
				filedata.fileName = file.value.split(/\\/g).pop();
			}
			else {
				fileguid = this.props.cu.createGuid();
				file.setAttribute('data-id', fileguid);
				event.files.push({
					file_ID: fileguid,
					docSubType_ID: data['acttype_' + no],
					docNo: data['actno_' + no],
					docDate: this.props.moment(data['actdate_' + no], 'DD.MM.YYYY').toDate(),
					fileName: file.value.split(/\\/g).pop()
				});
				file.id = 'actfile_' + fileguid;
				file.name = 'actfile_' + fileguid;
			}
		};

		const clearFile = file => {
			const fileguid = file.getAttribute('data-id');
			const i = event.files.findIndex(f => f.file_ID == fileguid);
			if (i >= 0)
				event.files.splice(i, 1);
		};

		if (!event.files) event.files = [];
		this.processFiles(rowel, form, submitFile, clearFile);

		form.reset();
	}

	processFiles(rowel, form, submitFile, clearFile) {
		const eventdata = rowel.querySelector('.eventdata');
		eventdata.innerHTML = '';

		const existedFiles = form.querySelector('.existedfiles');
		if (existedFiles)
			existedFiles.parentNode.removeChild(existedFiles);

		const files = form.querySelectorAll('input[type="file"]');
		for (let i = 0; i < files.length; i++) {
			const file = files[i];
			if (file.files.length > 0) {
				const newFile = file.cloneNode();
				newFile.removeAttribute('data-id');

				if (submitFile)
					submitFile(file);

				const parent = file.parentNode;
				eventdata.appendChild(file);
				parent.appendChild(newFile);
			}
			else if (file.hasAttribute('data-id')) {
				if (clearFile)
					clearFile(file);
			}
		}

		const selectfile = form.querySelector('input[name="selectfile"]');
		const selectfile_text = document.getElementById(selectfile.id + '_selected');

		const el = document.createElement('div');
		el.classList.add('existedDocs');
		el.innerHTML = selectfile_text.innerHTML;
		eventdata.appendChild(el);

		selectMultipleObjectsDialog.clear(selectfile.id, true);
		this.props.listview.clearselection(selectfile.id + '_str_list');
	}

	closeEventDialog(sender, rowel, row, period) {
		const event = period.event;

		if (event) {
			const d = document.getElementById(this.props.dialogID);
			const form = d.querySelector('form');

			this.processFiles(rowel, form);
		}

		this.props.au.processResult(sender);
	}

	documentMenuInit(cl) {
		const docmenus = document.querySelectorAll('.' + cl);
		docmenus.forEach(docmenu => {
			contextmenuproxy.init({
				triggerid: docmenu.id,
				popupid: docmenu.id + '_popup',
				triggeron: 'click',
				displaysaround: 'triggerbottom',
				closeonclick: true,
				//closeonscroll: true,
				type: 'default',
				storeparms: 'false',
				delay: '0'
			});
			docmenu.classList.replace(cl, cl + '-init');
		});
	}

	#readNSIEventMenu(el) {
		const el_a = el.querySelector('.document-nsimenu-no');
		const rowel = el.parentNode.parentNode;
		const parms = this.#getNSIRowParms(rowel);
		const row = this.state.rows.find(x => x.tI_ID == parms.tI_ID && x.isKA == parms.isKA);
		const period = row.periods.find(x => x.event && x.event.eventType == parms.eventType && new Date(x.startDate).getTime() == parms.eventDate.getTime() && new Date(x.finishDate).getTime() == parms.eventDate.getTime());
		if (period && period.event && period.event.files.length == 0 && this.state.types[period.event.eventType] == 1)
			el_a.classList.remove('hide');
		else
			if (period && period.event && period.event.files.length > 0) {
				const el_m = el.querySelector('.document-nsimenu-init');
				const el_mp = document.querySelector('#' + el_m.id + '_popup');
				if (el_mp.hasChildNodes)
					while (el_mp.firstChild) {
						el_mp.firstChild.remove();
					}

				period.event.files.forEach(file => {
					const d = document.createElement('div');
					if (file.document_ID) {
						const a = document.createElement('a');
						a.setAttribute('data-responsetype', 'arraybuffer');
						a.setAttribute('href', '/Expl_FileData/download?oid=' + file.file_ID);
						a.setAttribute('data-href', '/Expl_FileData/download?oid=' + file.file_ID);
						a.setAttribute('onclick', 'ajaxUtils.postEventFromElementWithApiResponse(this); return false;');
						a.innerText = file.docSubTypeTitle + '. ' + file.fileName;
						a.prepend(new Tango.HtmlWriter().Icon('download'));
						d.appendChild(a);
					}
					else {
						const sd = document.createElement('span');
						sd.innerText = file.fileName;
						const s = document.createElement('span');
						s.innerText = '(не сохранен)';
						s.style.color = '#f08080';
						sd.prepend(s);
						d.style.padding = '5px 0 5px 19px';
						d.appendChild(sd);
					}
					el_mp.appendChild(d);
				});
				el_m.classList.remove('hide');
				if (!el_a.classList.contains('hide')) el_a.classList.add('hide');
			}
	}
};

Tango.registerComponent(ApuList, sp => ({
	cu: sp.commonUtils,
	au: sp.ajaxUtils,
	listview: listview,
	moment: moment,
	btnSwitchCtor: id => sp.components.btnswitch(id, sp)
}));